export var FirstTimePolicyHolderUiType;
(function (FirstTimePolicyHolderUiType) {
    FirstTimePolicyHolderUiType[FirstTimePolicyHolderUiType["new"] = 1] = "new";
    FirstTimePolicyHolderUiType[FirstTimePolicyHolderUiType["repeat"] = 2] = "repeat";
    FirstTimePolicyHolderUiType[FirstTimePolicyHolderUiType["unset"] = 3] = "unset";
})(FirstTimePolicyHolderUiType || (FirstTimePolicyHolderUiType = {}));
